import { useEffect, useState } from 'react'
import { CSSTransition } from 'react-transition-group'
import { AccordionProps } from './types'

import * as S from './styles'

const Accordion = ({
  header,
  body,
  bodyHeight,
  bodyId,
  accordionShow,
  onAccordionChange,
  margin,
  automaticToggle = true,
  ...props
}: AccordionProps) => {
  const [showBody, setShowBody] = useState(accordionShow)

  useEffect(() => {
    setShowBody(accordionShow)
  }, [accordionShow])

  function toggleAccordion() {
    if (automaticToggle) {
      setShowBody(!showBody)
      onAccordionChange?.(!showBody)
    }
  }

  return (
    <div {...props}>
      <S.Header onClick={toggleAccordion} margin={margin}>
        {header}
      </S.Header>
      <CSSTransition in={showBody} unmountOnExit mountOnEnter timeout={300}>
        <S.Body height={bodyHeight} id={bodyId}>
          {body}
        </S.Body>
      </CSSTransition>
    </div>
  )
}

export default Accordion
